export const MINIMUM_GDS_PLUGIN_VECTOR_MEMORY = 4;
